import React from "react";
import styled, { keyframes } from "styled-components";

// Keyframes for shimmer animation
const shimmerKeyframe = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

// Shimmer effect container
const SkeletonBox = styled.div`
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  background-size: 1000px 104px;
  animation: ${shimmerKeyframe} 1.2s infinite linear;
  border-radius: ${(props) => props.rounded || "4px"};
  height: ${(props) => props.h || "20px"};
  width: ${(props) => props.w || "100%"};
  margin-bottom: ${(props) => props.mb || "0"};
`;

const SkeletonWrapper = styled.div`
  padding: 24px;
`;

const SkeletonCard = styled.div`
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 20px;
`;

const Stepper = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  margin: 0px 20px 20px 20px;
  justify-content: space-around;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  gap: 15px;
`;

const JournalSkeleton = () => {
  return (
    <>
      <SkeletonBox h="50px" w="100%" mb="8px" />
      <SkeletonWrapper>
        {/* Stepper */}

        <Stepper>
          {[...Array(4)].map((_, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <SkeletonBox h="24px" w="24px" rounded="50%" />
              <SkeletonBox h="16px" w="100px" />
            </div>
          ))}
        </Stepper>

        <SkeletonCard>
          {/* Subject */}
          <Wrapper>
            <SkeletonBox h="16px" w="120px" mb="8px" />
            <SkeletonBox h="40px" w="100%" />
          </Wrapper>

          {/* Message */}
          <Wrapper>
            <SkeletonBox h="16px" w="120px" mb="8px" />
            <SkeletonBox h="200px" w="100%" />
          </Wrapper>

          {/* Attachment */}
          <Wrapper>
            <SkeletonBox h="16px" w="120px" mb="8px" />
            <SkeletonBox h="150px" w="100%" />
          </Wrapper>

          {/* Buttons */}
          <ButtonRow>
            <SkeletonBox h="40px" w="80px" rounded="8px" />
            <SkeletonBox h="40px" w="80px" rounded="8px" />
            <SkeletonBox h="40px" w="80px" rounded="8px" />
          </ButtonRow>
        </SkeletonCard>
      </SkeletonWrapper>
    </>
  );
};

export default JournalSkeleton;
